export const attendee = {
    document: (roomSlug: string, documentId: string): string =>
        `/rooms/${roomSlug}/documents/#document/${documentId}/`,
    privateDocument: (roomSlug: string, documentId: string): string =>
        `/rooms/${roomSlug}/documents/#private/${documentId}/`,
    openDocument: (roomSlug: string, documentId: string): string =>
        `/rooms/${roomSlug}/documents/#document/${documentId}/preview/`,
    openPrivateDocument: (roomSlug: string, documentId: string): string =>
        `/rooms/${roomSlug}/documents/#private/${documentId}/preview/`,
    documents: (roomSlug: string, suffix?: string): string =>
        `/rooms/${roomSlug}/documents/${suffix || ''}`,
    privateDocuments: (roomSlug: string, suffix?: string): string =>
        `/rooms/${roomSlug}/documents/private/${suffix || ''}`,
    notifications: (roomSlug: string): string => `/rooms/${roomSlug}/documents/notifications/`
};

export const admin = {
    document: (roomSlug: string, documentId: string): string =>
        `/administrator/rooms/${roomSlug}/documents/document/${documentId}/`,
    privateDocument: (roomSlug: string, documentId: string): string =>
        `/administrator/rooms/${roomSlug}/documents/private/document/${documentId}/`,
    openDocument: (roomSlug: string, documentId: string): string =>
        `/administrator/rooms/${roomSlug}/documents/document/${documentId}/preview/`,
    openPrivateDocument: (roomSlug: string, documentId: string): string =>
        `/administrator/rooms/${roomSlug}/documents/private/document/${documentId}/preview/`,
    documents: (roomSlug: string, suffix?: string): string =>
        `/administrator/rooms/${roomSlug}/documents/${suffix || ''}`,
    privateDocuments: (roomSlug: string, suffix?: string): string =>
        `/administrator/rooms/${roomSlug}/documents/private/${suffix || ''}`,
    notifications: (roomSlug: string): string =>
        `/administrator/rooms/${roomSlug}/documents/notifications/`
};

export const api = {
    corporateDocuments: (): string => '/api/documents/',
    privateDocuments: (): string => '/api/private_documents/',
    libraries: (roomId: string): string => `/api/rooms/${roomId}/library/`,
    library: (roomId: string, nodeId: string): string => `/api/rooms/${roomId}/library/${nodeId}/`,
    uploadCorporateDocument: (id: string): string => `/api/documents/?room_id=${id}`,
    uploadPrivateDocument: (id: string): string => `/api/private_documents/?room_id=${id}`,
    notifyPrivateLibraryAnnotation: (id: string): string => `/api/private_documents/${id}/notify/`,
    notifyCorporateLibraryAnnotation: (id: string): string => `/api/documents/${id}/notify/`,
    previewCorporateDocuments: (id: string): string => `/api/documents/${id}/preview/`,
    previewPrivateDocuments: (id: string): string => `/api/private_documents/${id}/preview/`,
    registerChunkUpload: (): string => `/api/chunked_files/`,
    getChunkedStatus: (id: string): string => `/api/chunked_files/${id}/`,
    setChunkedFiles: (id: string): string => `/api/chunked_files/${id}/chunk/`,
    updateCorporateDocument: (id: string): string => `/api/documents/${id}/`,
    updatePrivateDocument: (id: string): string => `/api/private_documents/${id}/`,
    documentLabel: (): string => `/api/documents/labels/`,
    privateDocumentLabel: (): string => `/api/private_documents/labels/`,
    aggregatedDocuments: (): string => `/api/documents/aggregated/`,
    createDocumentLabel: (id: string): string => `/api/documents/labels/?room_id=${id}`,
    editDocumentLabel: (id: string): string => `/api/documents/labels/${id}/`,
    deleteDocumentLabel: (id: string): string => `/api/documents/labels/${id}/`,
    restoreDocumentLabel: (id: string): string => `/api/documents/labels/${id}/restore/`,
    createPrivateDocumentLabel: (): string => `/api/private_documents/labels/`,
    editPrivateDocumentLabel: (id: string): string => `/api/private_documents/labels/${id}/`,
    deletePrivateDocumentLabel: (id: string): string => `/api/private_documents/labels/${id}/`,
    bulkCorporateDocuments: (): string => `/api/documents/bulk/`,
    bulkPrivateDocuments: (): string => `/api/private_documents/bulk/`,
    signatures: (): string => '/api/me/signatures/',
    deleteSignature: (id: string): string => `/api/me/signatures/${id}/`,
    documentsManageableMembers: () => `/api/documents/manageable/members/`,
    documentsManageableGroups: () => `/api/documents/manageable/groups/`,
    createFolder: (id: string): string => `/api/rooms/${id}/library/`
};
